const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit')

const initialState = {
  localVersion: null,
  remoteVersion: null,
  lastChecked: new Date().toISOString(),
  shouldUpdate: false
}

export const fetchRemoteVersion = createAsyncThunk(
  'versionChecker/fetchRemoteVersion',
  async () => {
    const remoteJson = await fetch(
      `${document.location.origin}/metaData.json?${Math.floor(
        100000 + Math.random() * 900000
      )}`
    )

    const remoteData = await remoteJson.json()

    return remoteData.buildVersion
  }
)

const versionCheckerSlice = createSlice({
  name: 'versionChecker',
  initialState,
  reducers: {
    updateLocalVersion: (state, action) => {
      state.localVersion = action.payload
    }
  },
  extraReducers: {
    [fetchRemoteVersion.fulfilled]: (state, action) => {
      state.remoteVersion = action.payload
      state.lastChecked = new Date().toISOString()
    }
  }
})

export default versionCheckerSlice
